<template>
  <div class="order-pick-list">
    <div class="close" @click="handleClose">
      <z-icon class-prefix="zziconfont-6" color="#999999" size="20px" name="close" />
    </div>
    <section class="tab-header">
      <div
        id="my-sold"
        :class="{ selected: currentScreen === 'sold' }"
        @click="clickTab('sold')"
      >
        我卖出的
      </div>
      <div
        id="my-bought"
        :class="{ selected: currentScreen === 'bought' }"
        @click="clickTab('bought')"
      >
        我买到的
      </div>
    </section>
    <section class="list-area">
      <section class="list-filter">
        <div v-if="currentScreen === 'sold'" class="list-sub-filter">
          <div
            v-for="(item, index) in soldDataMap"
            :key="index"
            :class="{ selected: currentSellerOrderType == soldDataMap[index].orderType }"
            @click="clickSubTab(index)"
          >
            {{ item.name }}
          </div>
        </div>
        <div v-if="currentScreen === 'bought'" class="list-sub-filter">
          <div
            v-for="(item, index) in myBoughtData"
            :key="index"
            :class="{ selected: currentBuyerOrderType == myBoughtData[index].orderType }"
            @click="clickSubTab(index)"
          >
            {{ item.name }}
          </div>
        </div>
      </section>
      <section class="list-content">
        <pick-list
          v-show="currentScreen === 'sold'"
          class="my-sold-list"
          :showLoading="showLoading"
          :list="soldList"
          @to-bottom="refreshSold"
          @selected="select"
        ></pick-list>
        <pick-list
          v-show="currentScreen === 'bought'"
          class="my-bought-list"
          :showLoading="showLoading"
          :list="boughtList"
          @to-bottom="refreshBought"
          @selected="select"
        ></pick-list>
      </section>
    </section>
  </div>
</template>

<script>
import { Toast, Icon } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'
import { getCookie, isZljNative, isZljWx, isZljHtml } from '../../../../lib/utils'
import { getMyOrders } from '@api/resourceApi'
import PickList from '../PickList'

const DEFAULT_PAGE_SIZE = 20
export default {
  name: 'OrderPickList',
  data() {
    return {
      // 当前需要展示的tab
      currentScreen: 'sold',
      // 卖家订单tab类型
      currentSellerOrderType: '1',
      // 买家订单tab类型
      currentBuyerOrderType: '1',
      // 卖出的数组
      soldList: [],
      // 买入的数组
      boughtList: [],
      // 页码
      currentSoldPageNo: 2,
      // 页码
      currentBoughtPageNo: 2,
      // 是否展示loading
      isSoldListLoading: false,
      // 是否到头
      isSoldListEnd: false,
      isBoughtListLoading: false,
      isBoughtListEnd: false,
      // 是否展示loading
      showLoading: false
    }
  },
  computed: {
    userType() {
      let ret
      if (isZljNative() || isZljWx() || isZljHtml()) {
        ret = '2'
      } else {
        ret = this.currentScreen === 'sold' ? '1' : '2'
      }
      return ret
    },
    // 删除 免费送  orderType='2',手机保卖 orderType='3'
    soldDataMap() {
      let ret
      if (isZljNative() || isZljWx() || isZljHtml()) {
        ret = [
          {
            name: '新邮寄回收',
            orderType: '11'
          },
          {
            name: '上门回收',
            orderType: '10'
          }
        ]
      } else {
        ret = [
          {
            name: '普通订单',
            orderType: '1'
          },
          {
            name: '回收',
            orderType: '6'
          }
        ]
      }
      return ret
    },
    myBoughtData() {
      let ret
      if (isZljNative() || isZljWx() || isZljHtml()) {
        ret = [{ name: '找靓机订单', orderType: '7' }]
      } else {
        ret = [
          { name: '普通订单', orderType: '1' }
        ]
      }
      return ret
    },
    showListFilter() {
      if (isZljNative() || isZljWx() || isZljHtml()) {
        return false
      }
      return true
    }
  },
  methods: {
    formatRes(res) {
      return res.map((entity) => {
        return {
          type: 'order',
          businessType: entity.businessType,
          infoId: entity.infoId,
          id: entity.orderId,
          title: entity.title,
          orderType: entity.orderType,
          ypOrderDetailUrl: entity.ypOrderDetailUrl, // 1-竞拍 2-寄卖
          appDetailUrl: entity.appDetailUrl,
          price: Number(entity.orderPrice),
          payStar: entity.payStar,
          img: entity.infoPics && entity.infoPics.split('|')[0],
          time: entity.createTime,
          status: entity.status,
          businessId: entity.businessId || '',
          sellerOrderId: entity.sellerOrderId || '',
          orderSource: entity.orderSource || '',
          productNum: entity.productNum || 0,
          productPics: entity.productPics || []
        }
      })
    },
    clickTab(name) {
      this.currentScreen = name
      lego.send({
        pagetype: 'KEFUIM_ORDERPICKLIST',
        actiontype: 'TAB_CLICK',
        backup: {
          tab: name
        }
      })
      if (this.currentScreen === 'sold') {
        this.boughtList = []
        this.currentBoughtPageNo = 2
        this.isBoughtListEnd = false
        // this.$emit('emitLoading', true)
        this.showLoading = true
        this.fetchSold()
      } else {
        this.soldList = []
        this.currentSoldPageNo = 2
        this.isSoldListEnd = false
        // this.$emit('emitLoading', true)
        this.showLoading = true
        this.fetchBought()
      }
    },
    // 订单子类型查询
    clickSubTab(index) {
      // 发送埋点
      lego.send({
        pagetype: 'KEFUIM_ORDERPICKLIST',
        actiontype: 'TAB_SORT_CLICK',
        backup: {
          tab: index
        }
      })
      if (this.currentScreen === 'sold') {
        // 卖家标签
        // 记录当前的订单子类型
        this.currentSellerOrderType = this.soldDataMap[index].orderType
        // this.$emit('emitLoading', true)
        this.showLoading = true
        // 获取数据
        this.fetchSold()
      } else {
        // 买家标签
        // 记录当前的订单子类型
        this.currentBuyerOrderType = this.myBoughtData[index].orderType
        // this.$emit('emitLoading', true)
        this.showLoading = true
        // 获取数据
        this.fetchBought()
      }
    },
    fetchSold() {
      // 我卖出的订单
      getMyOrders({
        paramUid: getCookie('uid'), //|| getAdaptedUid(),
        orderType: this.currentSellerOrderType,
        userType: this.userType,
        // userType: this.currentScreen === 'sold' ? '1' : '2',
        pageNo: 1,
        pageSize: DEFAULT_PAGE_SIZE
      })
        .then((res) => {
          // this.$emit('emitLoading', false)
          this.showLoading = false
          console.log('fetchSold:::', res)
          this.soldList = this.formatRes(res)
        })
        .catch((err) => {
          console.error(err)
          // this.$emit('emitLoading', false)
          this.showLoading = false
          if (!err.errMsg) return
          Toast({
            message: err.errMsg
          })
        })
    },
    fetchBought() {
      // 我买到的订单
      getMyOrders({
        paramUid: getCookie('uid'), //|| getAdaptedUid(),
        orderType: this.currentBuyerOrderType,
        userType: this.userType,
        pageNo: 1,
        pageSize: DEFAULT_PAGE_SIZE
      })
        .then((res) => {
          // this.$emit('emitLoading', false)
          this.showLoading = false
          this.boughtList = this.formatRes(res)
        })
        .catch((err) => {
          console.error(err)
          // this.$emit('emitLoading', false)
          this.showLoading = false
          if (!err.errMsg) return
          Toast({
            message: err.errMsg
          })
        })
    },
    // 卖出的
    refreshSold() {
      if (this.isSoldListLoading || this.isSoldListEnd) return
      console.info('refresh sold.......')
      this.isSoldListLoading = true
      getMyOrders({
        paramUid: getCookie('uid'), //|| getAdaptedUid(),
        orderType: this.currentSellerOrderType,
        userType: this.userType,
        pageNo: this.currentSoldPageNo++,
        pageSize: DEFAULT_PAGE_SIZE
      })
        .then((res) => {
          this.isSoldListLoading = false
          if (res.length === 0) {
            this.isSoldListEnd = true
          }
          this.soldList = this.soldList.concat(res)
        })
        .catch((err) => {
          console.error(err)
          // this.$emit('emitLoading', false)
          this.showLoading = false
          if (!err.errMsg) return
          Toast({
            message: err.errMsg
          })
        })
    },
    // 买到的
    refreshBought() {
      if (this.isBoughtListLoading || this.isBoughtListEnd) return
      console.info('refresh bought.......')

      this.isBoughtListLoading = true
      getMyOrders({
        paramUid: getCookie('uid'), //|| getAdaptedUid(),
        orderType: this.currentBuyerOrderType,
        userType: this.userType,
        pageNo: this.currentBoughtPageNo++,
        pageSize: DEFAULT_PAGE_SIZE
      })
        .then((res) => {
          this.isBoughtListLoading = false
          if (res.length === 0) {
            this.isBoughtListEnd = true
          }
          this.boughtList = this.boughtList.concat(res)
        })
        .catch((err) => {
          console.error(err)
          // this.$emit('emitLoading', false)
          this.showLoading = false
          if (!err.errMsg) return
          Toast({
            message: err.errMsg
          })
        })
    },
    select(item) {
      this.$emit('selectOrder', item)
    },
    handleClose() {
      this.$emit('handleClose')
    }
  },
  created() {},
  mounted() {
    lego.send({
      pagetype: 'KEFUIM_ORDERPICKLIST',
      actiontype: 'PAGE_SHOW'
    })
    // this.$emit('emitLoading', true)
    this.showLoading = true
    if (isZljNative() || isZljWx() || isZljHtml()) {
      this.currentScreen = 'bought'
      this.currentBuyerOrderType = '7' // 默认选中'找靓机订单'
      this.currentSellerOrderType = '8' // 默认选中'找靓机订单’
      this.fetchBought()
    } else {
      this.fetchSold()
    }
  },
  components: {
    PickList,
    'z-icon': Icon
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
